<template>
    <div class="main-section home center">
        <div class="products-grid column wrap center">
            <!-- A slider to show images from -->
            <hooper class="img-slider" :infiniteScroll="true" :autoPlay="true" :playSpeed="3000">
                <slide v-for="(data,index) in sliderImages" :key="index"><img :src="imageSource+data.name" alt="" height="100%" width="100%"/></slide>
                <hooper-navigation slot="hooper-addons"/>
            </hooper>
            <div>
                <img src="img/Modalidades.png" alt="" class="modality">
            </div>

            <!-- Contains an automatic slider for images -->
            <div class="instructions">
                <img :src="imageSource+instructionImages[currentInstructionImage]"  width="100%" height="100%">
            </div>

        </div>
    </div>
</template>

<script>
import {Hooper, Slide, Navigation as HooperNavigation} from 'hooper';
import 'hooper/dist/hooper.css';
import { mapState, mapActions } from 'vuex';
export default {
    components: {
        Hooper,
        Slide,
        HooperNavigation
    },
    data(){
        return{
            imageSource: "img/",
            baner: "BanerMap.jpg",
            currentInstructionImage:0
        }
    },
    mounted(){
        this.ImagesInterval()
    },
    methods:{
        CheckWidth(e) {
            if(window.innerWidth <= 962){
                this.bigHopper=false
            }else{
                this.bigHopper=true
            }
        },
        ImagesInterval(){
            setInterval(() =>{
                this.currentInstructionImage >= 3 ? this.currentInstructionImage = 0 : this.currentInstructionImage++ 
            },3000)
        },
        ...mapActions(['GetFavorites'])
    },
    computed:{
        ...mapState(['sliderImages','instructionImages','currentCustomer','userFavorites'])
    }
}
</script>
<style scoped>

</style>
